import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Table,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import { v4 as uuidv4 } from "uuid";

import moment from "moment";
import {
  generateEAN13,
  generateItemReference,
  epcToEAN13,
  validateEAN13,
} from "../../../../utils/ean13Generator";

// RESPALDO: calcula el RFID (EAN-13) por hash de modelo-color-talla. La autoridad
// es el RFID GUARDADO que manda el backend (a.rfid): ~24% de los SKUs difiere del
// hash (probing por colision y etiquetas fisicas respetadas). Solo se usa si el
// backend todavia no envia el campo.
function calculaRFID(codigo, color, talla) {
  try {
    return generateEAN13(generateItemReference(codigo, color, talla));
  } catch (e) {
    return "";
  }
}

function TraspasosSalidaCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_TRASPASOS_SALIDA = import.meta.env.VITE_URL_TRASPASOS_SALIDA;
  const URL_ARTICULOS_TS = import.meta.env.VITE_URL_ARTICULOS_TS;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const AREAS_GENERAL = import.meta.env.VITE_AREAS_GENERAL;
  const URL_INVENTARIOS = import.meta.env.VITE_URL_INVENTARIOS;
  const URL_ARTICULOS_PROPORCION =
    import.meta.env.VITE_URL_ARTICULOS_PROPORCION;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [inventarios, setInventarios] = useState([]);
  const [fecha, setFecha] = useState(hoy);
  const [areas, setAreas] = useState([]);
  const [areaSalida, setAreaSalida] = useState("");
  const [areaDestino, setAreaDestino] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total, setTotal] = useState(0);
  const [articulosUnicos, setArticulosUnicos] = useState([]);

  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  
  const [inputFields, setInputFields] = useState([
    // {
    //   id: uuidv4(),
    //   articulos: "",
    //   articulosNombre: "",
    //   cantidad: 0,
    //   cantInv: 0,
    //   idInv: "",
    //   costoUnitario: 0,
    //   colores: [],
    //   tallas: [],
    //   colorNombre: "",
    //   tallaNombre: "",
    //   idColor: "",
    //   idTalla: "",
    // },
  ]);

  const [inputArticulos, setInputArticulos] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cajas: 0,
      articulosNombre: "",
      colores: [],
      tallas: [],
      EAN: "",
    },
  ]);

  const [manualInput, setManualInput] = useState({
    articulosNombre: "",
    articulos: "",
    idColor: "",
    idTalla: "",
    tallaNombre: "",
    cantInv: 0,
    cantidad: 0,
    colores: [],
    tallas: [],
    total: 0,
  });

  useEffect(() => {
    if (inputFields.length > 0) {
      const totalCantidad = inputFields.reduce(
        (acc, curr) => acc + parseFloat(curr.cantidad || 0),
        0
      );
      setTotal(totalCantidad);
    } else {
      setTotal(0);
    }
  }, [inputFields]);

  // esEnter: true cuando viene del Enter del lector (fin de lectura); si el
  // codigo no se encontro se limpia el campo aunque no tenga formato completo.
  async function buscarArticuloSingular(id, event, esEnter = false) {
    // El campo es NO controlado: el navegador acumula los caracteres del escáner
    // sin que React reescriba el value (un input controlado sin setState solo
    // entrega UN caracter por tecla y nunca llega a formar el código completo).
    const inputEl = event.target;
    const raw = (inputEl.value || "").trim();
    if (!raw) return;

    // El lector RFID entrega un EPC SGTIN-96 (24 hex). Lo convertimos a EAN-13.
    const epcDecoded = epcToEAN13(raw);
    const scanned = epcDecoded || raw;
    const scannedUpper = scanned.toUpperCase();

    // Mismo tag fisico ya contado: no sumar otra pieza.
    const esTagRFID = !!epcDecoded;
    // El lector puede mandar el EPC (24 hex) o su EAN-13 ya decodificado (13
    // digitos). Ambos son lectura de etiqueta: avisos no bloqueantes y contador.
    // Solo el EPC trae numero de serie, asi que solo con EPC se detecta un tag repetido.
    const esLecturaEtiqueta = esTagRFID || validateEAN13(scanned);
    const epc = raw.replace(/\s+/g, "").toUpperCase();
    if (esTagRFID && epcLeidosRef.current.has(epc)) {
      inputEl.value = "";
      setRfidStats((st) => ({ ...st, repetidas: st.repetidas + 1 }));
      return;
    }
    // idArticuloProporcion del renglon al que se sumo la pieza (null = no se sumo)
    let agregado = null;

    let encontrado = false;
    try {
      inventarios.map((a) => {
        // Coincide con el QR/EAN de la proporción o con el RFID (EAN-13) de la etiqueta
        if (
          (a.eanProporcion && a.eanProporcion.toUpperCase() === scannedUpper) ||
          (a.rfid && a.rfid === scanned)
        ) {
          encontrado = true;
          let idArticulo = a.idArticulo;
          let articulosNombre = a.nombre;
          let colores = a.colores;
          let tallas = a.tallas;
          let cantInv = parseFloat(a.cantidad);
          let idInv = a._id;
          let idColor = a.idColor;
          let idTalla = a.idTalla;
          let precio = a.venta;

          const avaible = inputFields.find(
            (i) => i.idArticuloProporcion === a.idArticuloProporcion
          );

          if (avaible) {
            // Create new array with updated object
            const updatedFields = inputFields.map((field) => {
              if (field.idArticuloProporcion === a.idArticuloProporcion) {
                return {
                  ...field,
                  cantidad: field.cantidad + 1,
                  total: (field.cantidad + 1) * field.precio,
                };
              }
              return field;
            });

            agregado = a.idArticuloProporcion;
            setInputFields(updatedFields);
            return null;
          }

          // const avaiable = inputFields.find((i) => {
          //   if (i.articulos === idArticulo) {
          //     Swal.fire({
          //       icon: "error",
          //       title: "Oops...",
          //       text: "El artículo ya ha sido agregado",
          //       showConfirmButton: false,
          //     });
          //     return true;
          //   }
          //   return false;
          // });
          // if (avaiable) {
          //   return;
          // }
          const newField = {
            id: uuidv4(),
            articulos: idArticulo,
            idInv: idInv,
            cantInv: cantInv,
            articulosNombre: articulosNombre,

            cantidad: 1,
            costoUnitario: a.costoUnitario,

            idTalla: a.idTalla,
            tallaNombre: a.talla,
            idColor: idColor,
            colorNombre: a.color,
            colores: a.colores,
            tallas: a.tallas,
            idArticuloProporcion: a.idArticuloProporcion,
          };

          agregado = a.idArticuloProporcion;
          setInputFields((prev) => [...prev, newField]);

          // Reset only specific fields after adding
          setManualInput((prev) => ({
            ...prev,
            idColor: "",
            articulos: "",
            articulosNombre: "",
            cantidad: 0,
            idTalla: "",
            tallaNombre: "",
            total: 0,
            precio: 0,
            idProporcion: "",
          }));
        }
        return null;
      });

      if (encontrado) {
        // Limpia el campo AHORA (sincrono) para el siguiente escaneo
        inputEl.value = "";
        if (esTagRFID && agregado) epcLeidosRef.current.set(epc, agregado);
        if (esLecturaEtiqueta && agregado) {
          setRfidStats((st) => ({ ...st, leidas: st.leidas + 1 }));
        }
      } else {
        // Código completo (EAN-13 o EPC RFID) escaneado pero sin existencia
        const codigoCompleto =
          validateEAN13(scanned) ||
          /^[0-9A-F]{24}$/i.test(raw.replace(/\s+/g, ""));
        if (codigoCompleto || esEnter) {
          inputEl.value = "";
          if (esLecturaEtiqueta) {
            setRfidStats((st) => ({ ...st, noEncontradas: st.noEncontradas + 1 }));
          }
          alertaEscaneo(esLecturaEtiqueta, {
            icon: "error",
            title: "Artículo no encontrado",
            text: "El código escaneado no tiene existencia en este almacén.",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            if (rfidScanRef.current) rfidScanRef.current.focus();
          });
        }
      }
    } catch (error) {
      console.log("error", error);
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
    }
  }

  const handleManualArticuloChange = (selectedArticulo) => {
    // Filter inventory for the selected article
    let inventario = inventarios.filter(
      (inv) => inv.idArticulo === selectedArticulo.idArticulo
    );

    // Get unique tallas from inventory
    let tallas = inventario.reduce((acc, curr) => {
      if (!acc.includes(curr.talla)) {
        acc.push(curr.talla);
      }
      return acc;
    }, []);

    // Get unique colores from inventory
    let colores = inventario.reduce((acc, curr) => {
      if (!acc.includes(curr.color)) {
        acc.push(curr.color);
      }
      return acc;
    }, []);

    // Filter selectedArticulo.colores to only include colors present in inventory
    let coloresRed = selectedArticulo.colores.filter((c) =>
      colores.includes(c.name)
    );

    // Filter selectedArticulo.tallas to only include sizes present in inventory
    let tallasRed = selectedArticulo.tallas.filter((t) =>
      tallas.includes(t.name)
    );

    if (selectedArticulo) {
      setManualInput({
        articulos: selectedArticulo.idArticulo,
        articulosNombre: selectedArticulo.nombre,
        idProporcion: "",
        colores: coloresRed,
        tallas: tallasRed,
        idColor: "",
        idTalla: "",
        cantidad: 0,
      });
    }
  };
  const handleManualInputChange = (event) => {
    const { name, value } = event.target;

    setManualInput((prev) => {
      const updatedInput = {
        ...prev,
        [name]: value,
      };

      // If changing talla, update tallaNombre
      if (name === "idTalla") {
        const selectedTalla = prev.tallas.find((t) => t._id === value);
        updatedInput.tallaNombre = selectedTalla ? selectedTalla.name : "";
      }

      // Calculate total whenever cantidad changes
      if (name === "cantidad") {
        updatedInput.cantidad = parseFloat(value);
        const inventario = inventarios.find(
          (inv) =>
            inv.idArticulo === manualInput.articulos &&
            inv.color === manualInput.colores[0].name
        );
        if (updatedInput.cantidad > inventario.cantidad) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `La cantidad excede tu inventario de ${inventario.cantidad}`,
            showConfirmButton: false,
          });
        }
      }

      return updatedInput;
    });
  };

  const handleManualAdd = async () => {
    if (
      !manualInput.articulosNombre ||
      !manualInput.idColor ||
      !manualInput.idTalla ||
      !manualInput.cantidad
    ) {
      return;
    }

    const selectedColor = manualInput.colores.find(
      (c) => c._id === manualInput.idColor
    );
    const selectedTalla = manualInput.tallas.find(
      (t) => t._id === manualInput.idTalla
    );

    // El catalogo tiene tallas y colores DUPLICADOS: mismo nombre con _id
    // distinto (SM, 4, 16, 18, 20, 22, 24). Buscar el inventario por NOMBRE y
    // mandar despues el _id elegido hacia que ambos no coincidieran, y el
    // backend rechazaba el traspaso con "MISMATCH: el inventario no coincide
    // con el color/talla seleccionado" aunque las piezas si existieran
    // (caso HSL5742CO PINK SM: 13 pzs en una SM y 12 en la otra).
    // Ahora se busca primero por _id exacto; solo si no hay, se cae al nombre.
    const inventario =
      inventarios.find(
        (inv) =>
          inv.idArticulo === manualInput.articulos &&
          inv.idColor === manualInput.idColor &&
          inv.idTalla === manualInput.idTalla
      ) ||
      inventarios.find(
        (inv) =>
          inv.idArticulo === manualInput.articulos &&
          inv.color === selectedColor.name &&
          inv.talla === selectedTalla.name
      );

    const cantidadFinal = inventario
      ? Math.min(inventario.cantidad, manualInput.cantidad)
      : manualInput.cantidad;

    if (inventario) {
      const avaible = inputFields.find(
        (i) => i.idArticuloProporcion === inventario.idArticuloProporcion
      );

      if (avaible) {
        // Create new array with updated object
        const updatedFields = inputFields.map((field) => {
          if (field.idArticuloProporcion === inventario.idArticuloProporcion) {
            return {
              ...field,
              cantidad: field.cantidad + manualInput.cantidad,
              total: (field.cantidad + manualInput.cantidad) * field.precio,
            };
          }
          return field;
        });

        setInputFields(updatedFields);
        // Reset only specific fields after adding
        setManualInput((prev) => ({
          ...prev,
          idColor: "",
          articulos: "",
          articulosNombre: "",
          cantidad: 0,
          idTalla: "",
          tallaNombre: "",
          total: 0,
          idProporcion: "",
        }));

        return null;
      }

      const newField = {
        id: uuidv4(),
        articulos: manualInput.articulos,
        idInv: inventario._id,
        cantInv: inventario.cantidad,
        articulosNombre: manualInput.articulosNombre,

        cantidad: parseFloat(manualInput.cantidad),
        costoUnitario: inventario.costoUnitario,

        // Los ids se toman del inventario encontrado (no de lo elegido en el
        // menu): si se cayo al match por nombre, son los del duplicado y es lo
        // que el backend va a validar contra ese mismo registro.
        idTalla: inventario ? inventario.idTalla : manualInput.idTalla,
        tallaNombre: selectedTalla ? selectedTalla.name : "",
        idColor: inventario ? inventario.idColor : manualInput.idColor,
        colorNombre: selectedColor ? selectedColor.name : "",
        colores: manualInput.colores,
        tallas: manualInput.tallas,
        idArticuloProporcion: inventario.idArticuloProporcion,
      };

      setInputFields((prev) => [...prev, newField]);

      // Reset only specific fields after adding
      setManualInput((prev) => ({
        ...prev,
        idColor: "",
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        idTalla: "",
        tallaNombre: "",
        total: 0,
        idProporcion: "",
      }));
    }
  };

  const [expandedTables, setExpandedTables] = useState({});

  const [validaBoton, setValidaBoton] = useState(true);
  const submittingRef = useRef(false);
  // Campo de escaneo QR/RFID NO controlado: el navegador acumula los caracteres
  // del lector sin que React reescriba el value entre teclas (ver VentasTiendasCreate).
  const rfidScanRef = useRef(null);
  // Lectura RFID masiva: cada tag (EPC) es UNA pieza fisica.
  //  - epcLeidosRef: EPC -> idArticuloProporcion del renglon donde se conto.
  //    Evita contar dos veces el mismo tag cuando el lector lo reporta varias veces.
  const epcLeidosRef = useRef(new Map());
  const [rfidStats, setRfidStats] = useState({
    leidas: 0,
    repetidas: 0,
    noEncontradas: 0,
  });
  // Para tags RFID el aviso es un toast: un modal le quita el foco al campo y
  // las lecturas siguientes del lector se pierden. QR/teclado conserva el modal.
  const alertaEscaneo = (esTagRFID, opts) =>
    Swal.fire(
      esTagRFID
        ? {
            toast: true,
            position: "top-end",
            icon: opts.icon,
            title: opts.text || opts.title,
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
          }
        : opts
    );

  // Borrador automatico: guarda el avance en localStorage para que no se
  // pierda al refrescar la pagina.
  const DRAFT_KEY = "traspasoSalidaDraft";
  const restoredRef = useRef(false); // ya evaluamos si habia borrador
  const canSaveRef = useRef(false); // se activa el guardado tras decidir

  useEffect(() => {
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
       axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
        const customeSizeOrder = allTallas.map((t) => t.name);
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const saveTraspasosSalida = async (event) => {
    event.preventDefault();

    // Validate that we have items to transfer
    const itemsToTransfer = inputFields.filter((item) => item.cantidad > 0);

    if (itemsToTransfer.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Atención",
        text: "No hay artículos con cantidad mayor a 0 para transferir",
      });
      return;
    }

    // Disable button immediately to prevent double-clicks
    if (submittingRef.current) return;
    submittingRef.current = true;
    setValidaBoton(false);
    toggleProgreso();

    try {
      // Prepare items array
      const items = itemsToTransfer.map((item) => ({
        articulos: item.articulos,
        cantidad: item.cantidad,
        inventarios: item.idInv,
        costoUnitario: item.costoUnitario,
        colores: item.idColor,
        tallas: item.idTalla,
        articulosProporcion: item.idArticuloProporcion,
      }));

      // Send everything in ONE consolidated request
      const response = await axios.post(
        `${URL_TRASPASOS_SALIDA}/batch`,
        {
          fecha,
          areaSalida,
          areaDestino,
          observaciones,
          user: user.id,
          total,
          items,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      // Success!
      toggleProgreso();
      // Limpia el borrador ya que el traspaso se guardo correctamente.
      localStorage.removeItem(DRAFT_KEY);
      Swal.fire("Good job!", "Creado con exito", "success");

      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (error) {
      console.log(error);
      toggleProgreso();
      submittingRef.current = false;
      setValidaBoton(true);

      // Handle validation errors from backend
      if (error.response?.data?.errors) {
        // El backend ya manda el modelo/color/talla dentro de message y tambien
        // por separado (descripcion, codigo, color, talla, disponible,
        // solicitado). Se escapa el texto porque va como html en el modal.
        const escapar = (txt) =>
          String(txt ?? "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");

        const errorMessages = error.response.data.errors
          .map((err) => {
            const titulo = err.descripcion || err.nombre || err.codigo || "Artículo";
            // message ya viene con la descripcion al inicio; se recorta para no repetirla.
            const detalle = String(err.message || "").startsWith(titulo)
              ? String(err.message).slice(titulo.length).replace(/^\s*→\s*/, "")
              : err.message || "";
            return `<li style="margin-bottom: 8px;">
              <strong>${escapar(titulo)}</strong><br />
              <span>${escapar(detalle)}</span>
            </li>`;
          })
          .join("");

        Swal.fire({
          icon: "error",
          title: "No se pudo guardar el traspaso",
          html: `<div style="text-align: left;">
            <p>Revisa estos artículos:</p>
            <ul style="font-size: 13px; max-height: 300px; overflow-y: auto; padding-left: 18px;">${errorMessages}</ul>
          </div>`,
          width: 600,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    }
  };
  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        cantInv: 0,
        idInv: "",
        costoUnitario: 0,
        colores: [],
        tallas: [],
        colorNombre: "",
        tallaNombre: "",
        idColor: "",
        idTalla: "",
      },
    ]);
  };

  // Si un renglon desaparece (se elimino o se limpio la captura), sus tags se
  // liberan para que puedan volver a leerse.
  useEffect(() => {
    const vivos = new Set(inputFields.map((f) => f.idArticuloProporcion));
    epcLeidosRef.current.forEach((v, k) => {
      if (!vivos.has(v)) epcLeidosRef.current.delete(k);
    });
  }, [inputFields]);

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if (i.cantInv >= event.target.value) {
          i[event.target.name] = event.target.value;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede tu inventario o Disponible!",
            showConfirmButton: false,
          });
          i.cantidad = 0;
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, event) {
    if (event.target.value.length >= 1) {
      inventarios.map((a) => {
        if (a.ean === event.target.value) {
          let articulosNombre = a.codigo + " " + a.nombre;
          let colores = a.colores;
          let tallas = a.tallas;
          let idArticulo = a.idArticulo;
          handleChangeInputArticuloProporcion(
            id,
            idArticulo,
            articulosNombre,
            colores,
            tallas
          );
        }
        return null;
      });
    } else {
      const newInputArticulos = inputArticulos.map((i) => {
        if (id === i.id) {
          i.articulos = event.target.value;
          i.articulosNombre = "";
          i.cajas = 0;
          i.colores = [];
          i.tallas = [];
        }
        return i;
      });
      setInputArticulos(newInputArticulos);
    }
  }
  const handleChangeInputArticuloUnico = (
    id,
    idArticulo,
    cantInv,
    idInv,
    costoUnitario,
    articulosNombre,
    colores,
    tallas
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.cantInv = parseFloat(cantInv);
        i.idInv = idInv;
        i.costoUnitario = parseFloat(costoUnitario);
        i.articulosNombre = articulosNombre;
        i.colores = colores;
        i.tallas = tallas;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);
  }

  function cargarInventariosSalida(e) {
    return axios
      .get(`${URL_INVENTARIOS}/traspasos/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        // Precalcula el RFID de cada pieza para poder escanear la etiqueta
        const allInventarios = res.data.map((a) => ({
          ...a,
          rfid: a.rfid !== undefined ? a.rfid : calculaRFID(a.codigo, a.color, a.talla),
        }));
        setInventarios(allInventarios);

        let unicos = allInventarios.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idArticulo === value.idArticulo)
        );
        setArticulosUnicos(unicos);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function jalaAlmacenSalida(e) {
    setAreaSalida(e);
    toggleProgreso();

    cargarInventariosSalida(e);

    setTimeout(() => {
      setModalProgreso(false);
    }, 3000);
  }

  function jalaAlmacenDestino(e) {
    setAreaDestino(e);

    // IMPORTANTE: NO recargar `inventarios` aquí. El inventario que se debe
    // descontar es el del almacén de SALIDA (cargado en jalaAlmacenSalida).
    // Antes este fetch sobrescribía `inventarios` con el stock del destino,
    // dejando cada idInv apuntando al área equivocada y provocando el error
    // "MISMATCH CRÍTICO DE ÁREA" al guardar.

    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        cantInv: 0,
        idInv: "",
        colores: [],
        tallas: [],
        colorNombre: "",
        tallaNombre: "",
        idColor: "",
        idTalla: "",
      },
    ]);
  }

  const handleChangeInputProporcion = (id, event) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
  };

  function BuscaArticuloProporcion(id, selectedArticulo) {
    inventarios.map((a) => {
      if (a.idArticulo === selectedArticulo.idArticulo) {
        let idArticulo = selectedArticulo.idArticulo;
        let articulosNombre =
          selectedArticulo.codigo + " " + selectedArticulo.nombre;
        let colores = a.colores;
        let tallas = a.tallas;
        handleChangeInputArticuloProporcion(
          id,
          idArticulo,
          articulosNombre,
          colores,
          tallas
        );
      }
    });
  }

  const handleChangeInputArticuloProporcion = (
    id,
    idArticulo,
    articulosNombre,
    colores,
    tallas
  ) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.articulosNombre = articulosNombre;
        i.cajas = 0;
        i.colores = colores;
        i.tallas = tallas;
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
  };

  function agregarProporcion(
    idArticulo,
    articulosNombre,
    cajas,
    colores,
    tallas
  ) {
    if (cajas === 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La cantidad debe ser mayor a 0",
      });
      return;
    }
    axios
      .get(`${URL_ARTICULOS_PROPORCION}Articulos/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        const avisos = [];
        const newInputFields = allArticulos
          .map((i) => {
            // Encuentra el inventario correspondiente
            const inventario = inventarios.find(
              (inv) =>
                inv.idArticulo === i.articulos[0]._id &&
                inv.color === i.colores[0].name &&
                inv.talla === i.tallas[0].name
            );

            const solicitado = i.cantidad * cajas;

            // Si no hay inventario de esa talla/color en el almacén de salida,
            // se omite la línea pero se avisa (antes se descartaba en silencio).
            if (!inventario) {
              avisos.push(
                `${i.colores[0].name} / ${i.tallas[0].name}: sin inventario en el almacén de salida, se omitió (${solicitado} pza)`
              );
              return null;
            }

            // Se topa a lo disponible; si se recorta, se avisa.
            const cantidadFinal = Math.min(inventario.cantidad, solicitado);
            if (cantidadFinal < solicitado) {
              avisos.push(
                `${i.colores[0].name} / ${i.tallas[0].name}: solicitado ${solicitado}, disponible ${inventario.cantidad}, se traspasa ${cantidadFinal}`
              );
            }

            return {
              id: uuidv4(),
              articulos: idArticulo,
              idInv: inventario._id,
              cantInv: inventario.cantidad,
              articulosNombre: articulosNombre,

              cantidad: cantidadFinal,
              costoUnitario: inventario.costoUnitario,

              idTalla: i.tallas[0]._id,
              tallaNombre: i.tallas[0].name,
              idColor: i.colores[0]._id,
              colorNombre: i.colores[0].name,
              colores: colores,
              tallas: tallas,
              idArticuloProporcion: i._id,
            };
          })
          .filter((i) => i !== null);

        setInputFields((prevInputFields) => {
          // Fusiona por inventario (idInv) para NO duplicar líneas del mismo
          // artículo+color+talla. Suma cantidades y respeta el tope de inventario.
          const updatedInputFields = [...prevInputFields];
          for (const nf of newInputFields) {
            const idx = updatedInputFields.findIndex(
              (f) => f.idInv === nf.idInv
            );
            if (idx >= 0) {
              const suma =
                (parseFloat(updatedInputFields[idx].cantidad) || 0) +
                (parseFloat(nf.cantidad) || 0);
              updatedInputFields[idx] = {
                ...updatedInputFields[idx],
                cantidad: Math.min(nf.cantInv, suma),
              };
            } else {
              updatedInputFields.push(nf);
            }
          }

          const tallaOrder = [
            "EECH",
            "ECH",
            "CH",
            "M",
            "G",
            "EG",
            "2EG",
            "3EG",
            "4EG",
            "5EG",
            "6EG",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "38",
            "39",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "48",
            "49",
            "50",
            "5/6",
            "7/8",
            "10/12",
            "14/16",
          ];

          const sortedInputFields = updatedInputFields.sort((a, b) => {
            if (a.articulosNombre < b.articulosNombre) return -1;
            if (a.articulosNombre > b.articulosNombre) return 1;

            if (a.colorNombre < b.colorNombre) return -1;
            if (a.colorNombre > b.colorNombre) return 1;

            return (
              tallaOrder.indexOf(a.tallaNombre) -
              tallaOrder.indexOf(b.tallaNombre)
            );
          });

          // Calculate total quantities and amounts
          const totalCantidad = sortedInputFields.reduce(
            (acc, curr) => acc + parseFloat(curr.cantidad),
            0
          );

          setTotal(totalCantidad);

          return sortedInputFields;
        });

        setInputArticulos([
          {
            id: uuidv4(),
            articulos: "",
            cajas: 0,
            articulosNombre: "",
            colores: [],
            tallas: [],
            EAN: "",
          },
        ]);

        if (avisos.length > 0) {
          Swal.fire({
            icon: "warning",
            title: "Algunas piezas se ajustaron",
            html: `<div style="text-align:left;"><p>No todo se agregó tal cual por inventario:</p><pre style="font-size:12px;max-height:300px;overflow-y:auto;">${avisos.join(
              "\n"
            )}</pre></div>`,
            width: 600,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // Al montar: si hay un borrador, pregunta si continuar o empezar uno nuevo.
  useEffect(() => {
    if (restoredRef.current) return;
    restoredRef.current = true;

    let draft = null;
    try {
      const saved = localStorage.getItem(DRAFT_KEY);
      if (saved) draft = JSON.parse(saved);
    } catch (e) {
      console.log("Error al leer borrador", e);
    }

    const tieneAvance =
      draft &&
      ((draft.inputFields && draft.inputFields.length > 0) || draft.areaSalida);

    if (!tieneAvance) {
      // No hay nada guardado: se habilita el autoguardado de una vez.
      canSaveRef.current = true;
      return;
    }

    Swal.fire({
      title: "Traspaso sin terminar",
      text: "Tienes un traspaso en progreso. ¿Deseas continuar con él o empezar uno nuevo?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Continuar con el anterior",
      cancelButtonText: "Empezar uno nuevo",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      allowOutsideClick: false,
      allowEscapeKey: false,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        // Restaura el avance guardado.
        if (draft.fecha) setFecha(draft.fecha);
        if (draft.observaciones !== undefined)
          setObservaciones(draft.observaciones);
        if (draft.areaDestino) setAreaDestino(draft.areaDestino);
        // Tags RFID ya contados en el borrador: sin esto, re-leer las mismas
        // piezas tras refrescar las sumaria dos veces.
        if (Array.isArray(draft.epcs)) {
          epcLeidosRef.current = new Map(draft.epcs);
        }
        if (draft.inputFields) setInputFields(draft.inputFields);
        if (draft.areaSalida) {
          setAreaSalida(draft.areaSalida);
          // Recarga el inventario del almacen de salida para poder seguir editando
          cargarInventariosSalida(draft.areaSalida);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // Solo si presionaron "Empezar uno nuevo" se descarta el borrador.
        // Si el dialogo se cerro por navegacion u otra razon, NO se borra.
        localStorage.removeItem(DRAFT_KEY);
      }
      // A partir de aqui ya se puede autoguardar.
      canSaveRef.current = true;
    });
  }, []);

  // Guarda el borrador cada vez que cambia el avance (despues de decidir).
  useEffect(() => {
    if (!canSaveRef.current) return;
    try {
      const hayAvance =
        inputFields.some((f) => f.articulos || parseFloat(f.cantidad) > 0) ||
        (areaSalida && areaSalida !== "0");
      if (hayAvance) {
        localStorage.setItem(
          DRAFT_KEY,
          JSON.stringify({
            fecha,
            areaSalida,
            areaDestino,
            observaciones,
            inputFields,
            epcs: Array.from(epcLeidosRef.current.entries()),
          })
        );
      }
    } catch (e) {
      console.log("Error al guardar borrador", e);
    }
  }, [fecha, areaSalida, areaDestino, observaciones, inputFields]);

  const options = articulosUnicos.map((option) => {
    const junta = option.codigo + " " + option.nombre;
    const firstLetter = option.codigo[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.traspasos_salida_create ? (
        <div className="card container col-12">
          <h3 align="center">Nuevo Traspaso Salida</h3>
          <Form onSubmit={saveTraspasosSalida}>
            <Row>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  disabled
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Almacen Salida</Label>
                {user.areas === AREAS_GENERAL ? (
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={areaSalida}
                    required
                    onChange={(e) => {
                      jalaAlmacenSalida(e.target.value);
                    }}
                  >
                    <option value="0">Almacen Salida</option>
                    {areas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (a._id != AREAS_GENERAL) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                ) : (
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={areaSalida}
                    required
                    onChange={(e) => {
                      jalaAlmacenSalida(e.target.value);
                    }}
                  >
                    <option value="0">Almacen Salida</option>
                    {areas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (user.areas === a._id) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                )}
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Almacen Destino</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={areaDestino}
                  required
                  onChange={(e) => {
                    setAreaDestino(e.target.value);
                  }}
                >
                  <option value="0">Almacen Destino</option>
                  {areas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a._id != AREAS_GENERAL) {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <h4 id="logoutBoton">TOTALES {total} pzas.</h4>
              </Col>
            </Row>

            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Selecciona</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cajas</Label>
              </Col>
            </Row>
            <h4 className="text-dark">
              <b>Agregar Caja</b>
            </h4>
            <>
              {/* QR Scanner Input */}
              <Row className=""></Row>

              {/* Proportion Input Section */}
              <Row className="">
                <Col md={2}>
                  <Label className="mr-sm-2">Escanea el QR</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Selecciona</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Articulo</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Cajas</Label>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={2}>
                  <Input
                    name="articulos"
                    type="string"
                    value={inputArticulos[0]?.EAN}
                    onChange={(event) => {
                      BuscaArticulo(inputArticulos[0].id, event);
                    }}
                  ></Input>
                </Col>
                <Col md={2}>
                  <Autocomplete
                    size="small"
                    value={inputArticulos[0]?.articulosNombre || ""}
                    onChange={(event, selectedArticulo) => {
                      BuscaArticuloProporcion(
                        inputArticulos[0]?.id || "template",
                        selectedArticulo
                      );
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option?.junta || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option._id}>
                        {option.codigo} {option.nombre}
                      </li>
                    )}
                  />
                </Col>
                <Col md={2}>
                  <Input
                    name="articulosNombre"
                    type="string"
                    placeholder="Articulo"
                    value={inputArticulos[0]?.articulosNombre || ""}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    name="cajas"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cajas"
                    value={inputArticulos[0]?.cajas || ""}
                    onChange={(event) =>
                      handleChangeInputProporcion(
                        inputArticulos[0]?.id || "template",
                        event
                      )
                    }
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="success"
                    disabled={
                      !inputArticulos[0]?.articulos || !inputArticulos[0]?.cajas
                    }
                    onClick={() =>
                      agregarProporcion(
                        inputArticulos[0]?.articulos,
                        inputArticulos[0]?.articulosNombre,
                        inputArticulos[0]?.cajas,
                        inputArticulos[0]?.colores,
                        inputArticulos[0]?.tallas
                      )
                    }
                    tabindex="-1"
                  >
                    Agregar
                  </Button>
                </Col>
              </Row>

              {/* MANUAL PRODUCT SECTION */}
              <h4 className="text-dark">
                <b>Agregar Pieza</b>
              </h4>
              <Row className="">
                <Col md={2}>
                  <Label className="mr-sm-2">Escanea QR / RFID</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Selecciona</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Articulo</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Color</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Talla</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Cantidad</Label>
                </Col>
              </Row>

              <Row>
                <Col md={2}>
                  <Input
                    name="idProporcion"
                    type="text"
                    autoComplete="off"
                    innerRef={rfidScanRef}
                    onChange={(event) => {
                      buscarArticuloSingular(manualInput.id, event);
                    }}
                    onKeyDown={(event) => {
                      // Enter o Tab (segun el sufijo configurado en el lector).
                      // El Enter del lector NO debe enviar el formulario.
                      if (
                        event.key === "Enter" ||
                        (event.key === "Tab" && event.target.value.trim())
                      ) {
                        event.preventDefault();
                        buscarArticuloSingular(manualInput.id, event, true);
                      }
                    }}
                  />
                  {(rfidStats.leidas > 0 ||
                    rfidStats.repetidas > 0 ||
                    rfidStats.noEncontradas > 0) && (
                    <small className="text-muted d-block">
                      RFID: {rfidStats.leidas} leídas · {rfidStats.repetidas}{" "}
                      repetidas · {rfidStats.noEncontradas} no encontradas
                    </small>
                  )}
                </Col>
                <Col md={2}>
                  <Autocomplete
                    size="small"
                    value={manualInput?.articulosNombre || ""}
                    onChange={(event, selectedArticulo) => {
                      handleManualArticuloChange(selectedArticulo);
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option?.junta || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option._id}>
                        {option.codigo} {option.nombre}
                      </li>
                    )}
                  />
                </Col>
                <Col md={2}>
                  <Input
                    type="text"
                    value={manualInput?.articulosNombre || ""}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    name="idColor"
                    type="select"
                    value={manualInput?.idColor || ""}
                    onChange={handleManualInputChange}
                  >
                    <option value="">Selecciona Color</option>
                    {manualInput?.colores?.map((color) => (
                      <option key={color._id} value={color._id}>
                        {color.name}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col md={1}>
                  <Input
                    name="idTalla"
                    type="select"
                    value={manualInput.idTalla || ""}
                    onChange={handleManualInputChange}
                  >
                    <option value="">Selecciona Talla</option>
                    {manualInput.tallas &&
                      manualInput.tallas.map((talla) => (
                        <option key={talla._id} value={talla._id}>
                          {talla.name}
                        </option>
                      ))}
                  </Input>
                </Col>
                <Col md={1}>
                  <Input
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    disabled={!manualInput?.idColor || !manualInput?.idTalla}
                    value={manualInput?.cantidad || 0}
                    onChange={handleManualInputChange}
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="success"
                    onClick={handleManualAdd}
                    disabled={
                      !manualInput?.articulosNombre ||
                      !manualInput?.idColor ||
                      !manualInput?.idTalla ||
                      !manualInput?.cantidad
                    }
                    tabindex="-1"
                  >
                    Agregar
                  </Button>
                </Col>
              </Row>
            </>

            <br />
            <hr />

            <div>
              {Object.entries(
                inputFields
                  .filter((field) => field.articulosNombre && field.articulos)
                  .reduce((acc, field) => {
                    const key = `${field.articulosNombre}`;
                    if (!acc[key]) {
                      acc[key] = {
                        articuloInfo: {
                          articulosNombre: field.articulosNombre,
                          articulos: field.articulos,
                          availableTallas: Array.from(
                            new Set(
                              inputFields
                                .filter(
                                  (f) =>
                                    f.articulosNombre === field.articulosNombre
                                )
                                .map((f) => f.tallaNombre)
                                .filter(Boolean)
                                .sort((a, b) => {
                                  return (
                                    customSizeOrder.indexOf(a) -
                                    customSizeOrder.indexOf(b)
                                  );
                                })
                            )
                          ),
                        },
                        colorGroups: [],
                      };
                    }

                    const existingColorIndex = acc[key].colorGroups.findIndex(
                      (item) => item.idColor === field.idColor
                    );

                    if (existingColorIndex === -1) {
                      acc[key].colorGroups.push({
                        id: field.id,
                        articulos: field.articulos,
                        articulosNombre: field.articulosNombre,
                        idColor: field.idColor,
                        colorNombre: field.colorNombre,
                        colores: field.colores,
                        quantities: {
                          [field.tallaNombre]: {
                            cantidad: field.cantidad,
                            id: field.id,
                            cantInv: field.cantInv,
                          },
                        },
                      });
                    } else {
                      acc[key].colorGroups[existingColorIndex].quantities[
                        field.tallaNombre
                      ] = {
                        cantidad: field.cantidad,
                        id: field.id,
                        cantInv: field.cantInv,
                      };
                    }
                    return acc;
                  }, {})
              ).map(([articuloNombre, { articuloInfo, colorGroups }]) => {
                // Calculate totals for this article
                const articleTotals = colorGroups.reduce(
                  (totals, group) => {
                    const quantitySum = Object.values(group.quantities).reduce(
                      (sum, q) => sum + (parseFloat(q.cantidad) || 0),
                      0
                    );

                    return {
                      items: totals.items + quantitySum,
                    };
                  },
                  { items: 0, price: 0 }
                );

                return (
                  <div key={articuloNombre} className="mb-8">
                    <div className="d-flex align-items-center border-t-2 border-gray-200 pt-2 pb-2 bg-gray-50">
                      <div className="d-flex align-items-center">
                        <Button
                          size="sm"
                          className="btn mr-3"
                          color="info"
                          onClick={() =>
                            setExpandedTables((prev) => ({
                              ...prev,
                              [articuloNombre]: !prev[articuloNombre],
                            }))
                          }
                        >
                          <i
                            className={`fas fa-chevron-${
                              expandedTables[articuloNombre] ? "up" : "down"
                            }`}
                          ></i>
                        </Button>
                        <h4 className="negrita mb-0 mr-4">{articuloNombre}</h4>
                      </div>
                      {!expandedTables[articuloNombre] && (
                        <div className="d-flex align-items-center">
                          <span
                            className="mr-4 text-dark"
                            style={{ fontSize: "18px" }}
                          >
                            <strong style={{ fontSize: "18px" }}>
                              Piezas:
                            </strong>{" "}
                            {articleTotals.items}
                          </span>

                          <span
                            className="text-dark"
                            style={{ fontSize: "18px" }}
                          ></span>
                        </div>
                      )}
                    </div>

                    {expandedTables[articuloNombre] && (
                      <Table borderless>
                        <thead>
                          <tr>
                            <th>Articulo</th>
                            <th>Color</th>
                            {articuloInfo.availableTallas.map((talla) => (
                              <th key={talla} style={{ maxWidth: "35px" }}>
                                {talla}
                              </th>
                            ))}
                            <th style={{ maxWidth: "80px" }}>Disponible</th>

                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {colorGroups.map((group) => (
                            <tr key={`${group.id}-${group.idColor}`}>
                              {/* Your existing row content */}
                              <td>
                                <Input
                                  name="articulo"
                                  type="string"
                                  placeholder="Articulo"
                                  value={group.articulosNombre}
                                  disabled
                                />
                              </td>
                              <td>
                                <Input
                                  name="idColor"
                                  type="select"
                                  value={group.idColor}
                                  onChange={(event) =>
                                    handleChangeInput(group.id, event)
                                  }
                                >
                                  <option value="">Selecciona</option>
                                  {group.colores?.map((a) => (
                                    <option key={a._id} value={a._id}>
                                      {a.name}
                                    </option>
                                  ))}
                                </Input>
                              </td>
                              {articuloInfo.availableTallas.map((talla) => (
                                <td key={talla} style={{ maxWidth: "60px" }}>
                                  <Input
                                    name="cantidad"
                                    type="number"
                                    min="0"
                                    step="any"
                                    value={
                                      group.quantities[talla]?.cantidad || 0
                                    }
                                    onChange={(event) =>
                                      handleChangeInputCantidad(
                                        group.quantities[talla]?.id || group.id,
                                        event
                                      )
                                    }
                                  />
                                </td>
                              ))}
                              <td style={{ maxWidth: "60px" }}>
                                <Input
                                  name="pendiente_surtir"
                                  type="text"
                                  value={
                                    Object.entries(group.quantities)
                                      .map(
                                        ([talla, data]) =>
                                          `${talla}:${data.cantInv}`
                                      )
                                      .join("|") || "0"
                                  }
                                  disabled
                                />
                              </td>
                              <td>
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="danger"
                                  disabled={inputFields.length === 1}
                                  onClick={() => handleRemoveFields(group.id)}
                                  tabindex="-1"
                                >
                                  <i className="fas fa-minus"></i>
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </div>
                );
              })}
            </div>

            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">TOTALES {total} pzas.</h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoTraspasosSalida"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default TraspasosSalidaCreate;
